<template>
    <div id="find-jeweler-page">
        <find-jeweler></find-jeweler>
        <div class="container">
            <paging-navigator :links="pagingLinks"></paging-navigator>
            <h2 class="home-title page-title">Find a Jewelry store By State</h2>
            <p class="noto-sans-font-title text-center">Last Updated {{ getDate }}</p>
            <objects-row @sendGAClick="sendGA" :countInRow="5" :showSeoCities="false" :objectsToShow="objectsToShow"></objects-row>
            <common-questions titleTag="h3" questionsTag="h4" title="How to Choose the Best Jewelry Store? Q&A" :questions="getQuestions"></common-questions>
        </div>
        <successfully-loaded v-if="showSuccess"></successfully-loaded>
    </div>
</template>

<script>
import { chunk } from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import CommonQuestions from "../../../components/CommonQuestions";
import PagingNavigator from "../../../components/PagingNavigator.vue";
import SuccessfullyLoaded from "../../../components/SuccessfullyLoaded";
import FindJeweler from "../../../components/store-locator/FindJeweler.vue";
import { getBeginningOfMonth } from "../../../helpers";
import questions from "../../../static-data/search-results/commonQuestions";
import ObjectsRow from "./ObjectsRow.vue";

export default {
    name: "find-jeweler-page",
    data() {
        return {
            ga_listWasFired: false,
            pagingLinks: [
                {
                    name: "Home",
                    url: "/",
                },
                {
                    name: "Store Locator",
                    url: this.$route.path,
                },
            ],
        };
    },
    components: {
        "paging-navigator": PagingNavigator,
        "objects-row": ObjectsRow,
        "find-jeweler": FindJeweler,
        "common-questions": CommonQuestions,
        "successfully-loaded": SuccessfullyLoaded,
    },
    mounted() {
        this.removeStoreData();
        this.$route ? this.setCurrentPage(this.$route.name) : null;
        this.$route ? this.setCurrentPath(this.$route.fullPath) : null;
        this.sendGaIfNeeded();

    },
    computed: {
        ...mapState("willyou", ["states", "currentPath"]),
        ...mapGetters("willyou", ["getCurrentMeta"]),
        ga_impressions() {
            let returnArr = [];
            let objectsArray = this.objectsToShow.map((state) => {
                returnArr.push({
                    name: state.name,
                    list: this.dl_ecommerceLabel,
                    position: state.position,
                });
                state.cities.map((city) => {
                    returnArr.push({
                        name: city.name,
                        list: this.dl_ecommerceLabel,
                        position: city.position,
                    });
                });
                return returnArr;
            });
            return returnArr;
        },
        objectsToShow() {
            return this.states;
        },
        getQuestions() {
            return questions;
        },
        showSuccess() {
            return this.states && this.states.length > 0;
        },
        getDate() {
            return getBeginningOfMonth();
        },
        dl_ecommerceLabel() {
            return "jeweler store locator-state+city";
        },
    },
    watch: {
        showSuccess(newVal) {
            newVal ? this.sendGaIfNeeded() : null;
        },
        currentPath() {
            this.showSuccess ? this.sendGaIfNeeded() : (this.ga_listWasFired = false);
        },
    },
    methods: {
        ...mapActions("willyou", ["setCurrentPage", "setCurrentPath", "removeStoreData"]),
        // Check if need to send Google Analytics Object and fire it if needed.
        sendGaIfNeeded() {
            if (!this.ga_listWasFired && this.objectsToShow.length > 0) {
                this.sendGA({ impressions: [...this.ga_impressions] });
                this.ga_listWasFired = true;
            }
        },
        sendGA(payload) {
            let gaObj = {
                event: payload.isClicked ? "product click" : "product list",
                ecommerceLabel: this.dl_ecommerceLabel,
                ecommerce: {},
            };
            if (payload.isClicked) {
                // product click event
                gaObj.ecommerce.click = {
                    actionField: {
                        list: this.dl_ecommerceLabel,
                        action: "click",
                    },
                    products: {
                        0: {
                            name: payload.products[0].name,
                            position: payload.products[0].position,
                        },
                    },
                };
            } else {
                // product list event
                gaObj.ecommerce.currencyCode = "USD";
                gaObj.ecommerce.impressions = payload.impressions;
            }

            let impressionsArrayLength = gaObj.ecommerce && gaObj.ecommerce.impressions ? gaObj.ecommerce.impressions.length : 0;
            // Store mode page: if more than 200 impressions are loaded, split them to 200 chunks and send.
            if (impressionsArrayLength > 200) {
                let impressions = chunk(gaObj.ecommerce.impressions, 200);
                let counter = 0;
                impressions.map((imp) => {
                    counter++;
                    setTimeout(() => {
                        gaObj.ecommerce.impressions = imp;
                        window.dataLayer.push(gaObj);
                    }, 100 * counter);
                });
            } else window.dataLayer.push(gaObj);
        },
    },
    metaInfo() {
        return this.getCurrentMeta;
    },
};
</script>

<style lang="scss" scoped>
#find-jeweler-page {
    min-height: 100vh;
    padding-top: 108px;

    h2.page-title {
        font-size: 44px;
        text-align: center;
    }
}
</style>
